export default {
  'AddItemTextInput.error': {
    en: 'Your url is not valid.',
    fr: "Votre URL n'est pas valide.",
  },
  'AddItemTextInput.addSong': { en: 'Add Song', fr: 'Ajouter une chanson' },
};
